/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `zones_target` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class ZonesTargetMesg : Mesg {
    public constructor() : super("ZonesTarget", Profile.MesgNum.ZONES_TARGET)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** max_heart_rate. */
    public var maxHeartRate: UByte?
        get() = getFieldValue(MAX_HEART_RATE_FIELD_NUM) as? UByte
        set(value) = setFieldValue(MAX_HEART_RATE_FIELD_NUM, value)

    /** threshold_heart_rate. */
    public var thresholdHeartRate: UByte?
        get() = getFieldValue(THRESHOLD_HEART_RATE_FIELD_NUM) as? UByte
        set(value) = setFieldValue(THRESHOLD_HEART_RATE_FIELD_NUM, value)

    /** functional_threshold_power. */
    public var functionalThresholdPower: UShort?
        get() = getFieldValue(FUNCTIONAL_THRESHOLD_POWER_FIELD_NUM) as? UShort
        set(value) = setFieldValue(FUNCTIONAL_THRESHOLD_POWER_FIELD_NUM, value)

    /** hr_calc_type. */
    public var hrCalcType: HrZoneCalc?
        get() = (getFieldValue(HR_CALC_TYPE_FIELD_NUM) as? UByte)?.let { HrZoneCalc.fromValue(it) }
        set(value) = setFieldValue(HR_CALC_TYPE_FIELD_NUM, value?.value)

    /** pwr_calc_type. */
    public var pwrCalcType: PwrZoneCalc?
        get() = (getFieldValue(PWR_CALC_TYPE_FIELD_NUM) as? UByte)?.let { PwrZoneCalc.fromValue(it) }
        set(value) = setFieldValue(PWR_CALC_TYPE_FIELD_NUM, value?.value)

    public companion object {
        public const val MAX_HEART_RATE_FIELD_NUM: UByte = 1u
        public const val THRESHOLD_HEART_RATE_FIELD_NUM: UByte = 2u
        public const val FUNCTIONAL_THRESHOLD_POWER_FIELD_NUM: UByte = 3u
        public const val HR_CALC_TYPE_FIELD_NUM: UByte = 5u
        public const val PWR_CALC_TYPE_FIELD_NUM: UByte = 7u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[1] = Field("MaxHeartRate", 1u, BaseType.UINT8, 1.0, 0.0, "", false)
            fields[2] = Field("ThresholdHeartRate", 2u, BaseType.UINT8, 1.0, 0.0, "", false)
            fields[3] = Field("FunctionalThresholdPower", 3u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[5] = Field("HrCalcType", 5u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[7] = Field("PwrCalcType", 7u, BaseType.ENUM, 1.0, 0.0, "", false)
            return fields
        }
    }
}
